<template>
  <div class="add-user">
    <ui-v :rules="rules" ref="addUserForm">
      <ui-input type="email" v-model="email" placeholder="input user email" name="email"></ui-input>
      <ui-input type="password" v-model="password" placeholder="input user password" name="password"></ui-input>
    </ui-v>
    <p>
      <select v-model="lang">
        <option disabled value="">选择语言</option>
        <option>zh-CN</option>
        <option>zh-HK</option>
        <option>en-US</option>
      </select>
      <ui-checkbox v-model="activation">需要验证邮件</ui-checkbox>
    </p>
    <ui-button @click="addUser">添加用户</ui-button>
  </div>
</template>
<script>
import adminApi from '../../api/admin.js'
export default {

  name: 'add-user',

  data() {
    return {
      email: '',
      password: '',
      lang: '',
      activation: false,
      rules: {
        email: [{
          type: "required",
          trigger: "submit",
          message: this.$t("empty") + this.$t("email")
        }, {
          type: "email",
          trigger: "submit",
          message: this.$t("typeValidEmail")
        }],
        password: [{
            type: "required",
            trigger: "submit",
            message: this.$t("empty") + this.$t("password")
          },
          {
            type: "minLength",
            length: 6,
            trigger: "submit",
            message: this.$t("password") + this.$t("tooShort", { len: 6 })
          }
        ]
      }
    }
  },
  methods: {
    addUser() {
      this.$refs['addUserForm'].validate().then(_ => {
        return adminApi.addUser({
          email: this.email,
          password: this.password,
          lang: this.lang,
          activation: this.activation
        })
      }).then(res => {
        this.$UiToast('add success')
      }).catch(err => {
        this.$UiToast.error('system error')
      })
    }
  }
}

</script>
<style lang="css" scoped>
</style>
